import * as React from 'react';
import Project from 'src/entities/Project';
import InvestorType from 'src/entities/InvestorType';
import { RootState } from 'src/reducers/RootReducer';
import { connect, Dispatch } from 'react-redux';
import {
  getInvestorType,
  GetInvestorTypeAction
} from 'src/actions/investor-type/get/GetInvestorType.actions';
import { getUser, GetUserAction } from 'src/actions/user/get/GetUser.actions';
import * as getUserTypes from 'src/actions/user/get/Types';
import InvestmentInformationComponent, { InvestmentInformationComponentProps }
  from 'src/modules/modals/investment-funnel/InvestmentInformation.component';
import { openModal, OpenModal } from 'src/actions/modal';
import InvestmentFormContainer from 'src/modules/modals/investment-funnel/InvestmentForm.container';
import Modal from 'src/modules/commons/modal-handler/jQueryModal';
import Person from 'src/entities/Person';
import * as moment from 'moment';
import ExpiredDataContainer from 'src/modules/modals/investment-funnel/expired-data/ExpiredData.container';

interface StateProps {
  project?: Project;
  loggedUserData: number | null;
  activeProfile?: Person;
  investorType?: InvestorType;
}

interface DispatchProps {
  getUser(userId: number): Promise<GetUserAction>;
  getInvestorType(personId: number, personType: string): Promise<GetInvestorTypeAction>;
  openModal(component: JSX.Element): void;
}

interface Props extends StateProps, DispatchProps {
  modalRef?: Modal;
  handleBackButton?: () => void;
}

class InvestmentInformationContainer extends React.Component<Props> {

  public componentWillMount(): void {
    if (this.props.loggedUserData && !this.props.activeProfile) {
      this.props.getUser(this.props.loggedUserData).then((response) => {
        if (
          response.type === getUserTypes.GET_USER_SUCCESS &&
          this.props.activeProfile!.personType === 'physical'
        ) {
          this.props.getInvestorType(this.props.activeProfile!.id, this.props.activeProfile!.personType);
        }
      });
    } else if (
      this.props.loggedUserData &&
      this.props.activeProfile &&
      this.props.activeProfile!.personType === 'physical'
    ) {
      this.props.getInvestorType(this.props.activeProfile.id, this.props.activeProfile!.personType);
    }
  }

  public render(): React.ReactNode {
    return (this.props.project && this.props.investorType ?
      <InvestmentInformationComponent {...this.getComponentProps()} /> : null
    );
  }

  private handleClick(): void {
    const expirationDate = this.props.activeProfile!.idExpirationDate;
    const expiredData = (expirationDate &&
      expirationDate < moment(Date.now()).add(1, 'months'));
    if (expiredData) {
      // open expired data modal
      this.props.openModal(
        <ExpiredDataContainer project={this.props.project!} />
      );
      return;
    }
    this.props.openModal(
      <InvestmentFormContainer />
    );
  }

  private getComponentProps(): InvestmentInformationComponentProps {
    return {
      investorType: this.props.investorType,
      project: this.props.project!,
      handleClick: () => this.handleClick(),
      modalRef: this.props.modalRef!,
    };
  }
}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>): DispatchProps => ({
    getInvestorType: (personId: number, personType: string): Promise<GetInvestorTypeAction> => (
      dispatch(getInvestorType(personId, personType))
    ),
    getUser: (userId: number): Promise<GetUserAction> => (
      dispatch(getUser(userId))
    ),
    openModal: (component: JSX.Element): OpenModal => (
      dispatch(openModal(component))
    )
  });

const mapStateToProps: (state: RootState) => StateProps = (state: RootState):
  StateProps => ({
    project: state.getProject.project || undefined,
    loggedUserData: state.authentication.loggedUserData,
    activeProfile: state.getUser.activeProfile,
    investorType: state.getInvestorType.investorType || undefined,
  });

export default connect(mapStateToProps, mapDispatchToProps)(InvestmentInformationContainer);



// WEBPACK FOOTER //
// ./src/modules/modals/investment-funnel/InvestmentInformation.container.tsx